console.log('coderivy init');

var coderIvyPage;
var coderIvyStoreType = 'shopify';
const path = window.location.pathname;
const isProductPage = path.startsWith('/products/');
if (path === '/') {
        coderIvyPage = "home";
}

if (path.startsWith('/products/')) {
        coderIvyPage = "pdp";
}

if (path.startsWith('/search')) {
        coderIvyPage = "emptysearch";

}


console.log('coderivy page', coderIvyPage);

(function () {
  if (window.__coderivyLoaded) return;
  window.__coderivyLoaded = true;

  window.componentInjectorConfig = {
    clientId: "macoma"
  };
  console.log('coderivy config', window.componentInjectorConfig);

  var script = document.createElement("script");
  script.src = "https://coderivy-ai.github.io/coder-shelf-gtm/prod/loader.js";
  script.defer = true;
  document.head.appendChild(script);
})();

function start() {
window.componentInjector.load();
  console.log('coderivy loaded')
}

if (document.readyState === "complete") {
  start();
} else {
  window.addEventListener("load", start);
}